module.exports = __webpack_public_path__ + "img/wep_spear04.ff1d1def.png";